module.exports = function() {
    let Objects = {};

    Objects.toCamelCase = function (myString) {
        return myString.replace(/_([a-z])/g, function (g) { return g[1].toUpperCase(); });
    };

    Objects.translateKeysToCamelCase = function (myObject) {
        const self = this;
        let myNewObject = {};
        for (let name in myObject) {
            let camelCaseName = self.toCamelCase(name);
            if (myObject[name] !== null && typeof myObject[name] === 'object') {
                myNewObject[camelCaseName] = self.translateKeysToCamelCase(myObject[name]);
            } else {
                myNewObject[camelCaseName] = myObject[name];
            }
        }

        return myNewObject;
    };

    return Objects;
};